import { PlaceTagValueSrc } from 'interfaces/vector.interface';
const extractValuesForPlaceTag = (valueSrc: PlaceTagValueSrc): any => {
	let value: any = [];
	switch (valueSrc.valueType) {
		case 'VALUE_TYPE_DOUBLE':
			value = valueSrc.floatValues;
			break;
		case 'VALUE_TYPE_STRING':
			value = valueSrc.stringValues;
			break;
		case 'VALUE_TYPE_BOOLEAN':
			value = valueSrc.boolValues;
			break;
		case 'VALUE_TYPE_INT64':
			value = valueSrc.int64Values;
			break;
		case 'VALUE_TYPE_INT32':
			value = valueSrc.int32Values;
			break;
		case 'VALUE_TYPE_NSV_PLACE_ID':
			value = valueSrc.nsvPlaceIdValues;
			break;
		case 'VALUE_TYPE_OVERLAPPING_PLACE':
			value = valueSrc.overlappingPlaceValues;
			break;
		default:
			value = [];
	}
	return value;
};

export default extractValuesForPlaceTag;
